/* eslint-disable react/prop-types */
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const LoadComponent = ({ loading, children, count = 1, ...prop }) => {
  if (loading) {
    return <Skeleton {...prop} count={count} />;
  }
  return children;
};

export default LoadComponent;
